/**
 * 响应码枚举
 */
export const enum ResultCode {
  /**
   * 成功
   */
  SUCCESS = 0,
  /**
   * 成功
   */
  SUCCESS200 = 200,
  /**
   * 错误
   */
  ERROR = -1,

  /**
   * 访问令牌无效或过期
   */
  ACCESS_TOKEN_INVALID = 401,

  /**
   * 刷新令牌无效或过期
   */
  REFRESH_TOKEN_INVALID = "A0231",
}
